import React from 'react';
import { Link } from 'react-router-dom';
import NewsletterForm from './NewsletterForm';
import { IconInstagram, IconSpotify } from './SocialIcons';
import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <h2>Libros para Viajeros</h2>
          <p>Literatura, viajes y contenido para quienes nunca dejan de descubrir historias.</p>
          <div className="site-footer__social">
            <a href="https://www.instagram.com/librosparaviajeros/" target="_blank" rel="noreferrer" aria-label="Instagram">
              <IconInstagram />
            </a>
            <a href="https://open.spotify.com/show/033E5l73Ws2en6WGCanK96" target="_blank" rel="noreferrer" aria-label="Podcast Entre Páginas en Spotify">
              <IconSpotify />
            </a>
          </div>
        </div>

        <nav className="site-footer__nav">
          <div>
            <h4>Contenido</h4>
            <Link to="/resenas">Reseñas</Link>
            <Link to="/que-leer">Qué leer</Link>
            <Link to="/viajes-literarios">Viajes literarios</Link>
            <Link to="/ferias-eventos">Ferias y eventos</Link>
            <Link to="/podcast">Podcast Entre Páginas</Link>
          </div>
          <div>
            <h4>Profesional</h4>
            <Link to="/trabaja-conmigo">Trabaja conmigo</Link>
            <Link to="/colaboraciones">Colaboraciones</Link>
            <Link to="/media-kit">Media Kit</Link>
            <Link to="/contacto">Contacto</Link>
          </div>
          <div>
            <h4>Legal</h4>
            <Link to="/aviso-legal">Aviso legal</Link>
            <Link to="/privacidad">Privacidad</Link>
            <Link to="/cookies">Cookies</Link>
            <Link to="/condiciones-de-uso">Condiciones de uso</Link>
            <Link to="/politica-editorial">Política editorial</Link>
            <Link to="/politica-de-colaboraciones">Política de colaboraciones</Link>
          </div>
        </nav>

        <NewsletterForm />
      </div>
      <p className="site-footer__copyright">
        © {new Date().getFullYear()} Libros para Viajeros. Todos los derechos reservados.
      </p>
    </footer>
  );
}

export default Footer;
